import React from 'react';
import { Link } from 'react-router-dom';

const ProcessSection = () => {
  const locations = [
    { 
      name: 'SOUTH AUSTRALIA', 
      color: '#76B82A', 
      shortName: 'SA',
      link: '/properties'
    },
    { 
      name: 'QUEENSLAND', 
      color: '#550d63', 
      shortName: 'QLD',
      link: '/properties'
    },
    { 
      name: 'VICTORIA', 
      color: '#FFD700', 
      shortName: 'VIC',
      link: '/properties'
    }
  ];

  return (
    <div className='flex justify-center items-center'>
    <div className="container bg-white py-32">
      <div className="p-4 md:p-6 md:px-24 flex flex-col md:flex-row gap-6 md:gap-8">
        <div className="w-full md:w-1/2">
          <h2 className="text-3xl md:text-5xl font-bold text-primary mb-6 md:mb-8 text-center md:text-left">
            Caring for more than 100 NDIS participants in Australia
          </h2>
          
          <div className="space-y-3 md:space-y-4 flex flex-col items-center md:items-start">
            {locations.map((location) => (
              <Link 
                key={location.name}
                to={location.link}
                className="block w-full max-w-[250px] md:w-64"
              >
                <div
                  className="py-2 md:py-3 px-4 md:px-6 rounded-full text-center font-semibold w-full transition-opacity hover:opacity-90"
                  style={{
                    backgroundColor: location.color,
                    color: location.color === '#76B82A' || location.color === '#550d63' ? 'white' : 'black'
                  }}
                >
                  {typeof window !== 'undefined' && window.innerWidth <= 768 ? location.shortName : location.name}
                </div>
              </Link>
            ))}
          </div>
        </div>
        
        <div className="w-full md:w-1/2 flex justify-center md:justify-start">
          <div className="relative w-full max-w-[400px] md:max-w-none">
            <img 
              src="/Icons/LGA-HomePage-AustraliaMap-Graphic.svg"
              alt="Map of Australia showing NDIS service locations in South Australia, Queensland, and Victoria"
              className="w-auto h-128 object-contain"
            />
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default ProcessSection;